// @flow
import React from 'react';
import { fromNow, resizeImage, numberWithCommas } from 'lib/common';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { MdLock, MdRemoveCircle } from 'react-icons/md';

import 'moment/locale/ko';
import './ProductCard.scss';
import FakeBannerCard from '../FakeBannerCard';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  displayName: string,
  title: string,
  body: string,
  badge: any,
  price: string,
  supplier: string,
  date: string,
  urlSlug: string,
  userThumbnail: ?string,
  oneColumn?: boolean,
  commentsCount: number,
  hideUsername?: boolean,
  isPrivate: boolean,
  isTrending?: boolean,
};

const ProductCard = ({
  thumbnail,
  username,
  displayName,
  title,
  badges,
  price,
  supplier,
  urlSlug,
  userThumbnail,
  oneColumn,
  hideUsername,
  isPrivate,
  isTrending,
}: Props) => {
  const link = `/@${username}/products/${urlSlug}`;
  const imgUrl = resizeImage(thumbnail, 250, 250);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  // 백엔드에서 배지 데이터를 { name, color } 형태로 받음
  const badgeList =
    badges.length && badges[0].name ? badges : badges.map(name => ({ name, color: '#6c757d' }));
  const displayBadges = badgeList.slice(0, 3);
  return (
    <Link
      to={link}
      className={cx('ProductCard', {
        'one-column': oneColumn,
        empty: !thumbnail,
      })}
    >
      {thumbnail && <div className={cx('thumbnail-wrapper')} style={style} />}
      <div className="card-content">
        {/* {!oneColumn && (
          <Link className="user-thumbnail-wrapper" to={`/@${username}/products`}>
            <img
              src={resizeImage(
                userThumbnail || 'https://images.cacheby.com/default_thumbnail.png',
                100,
                100,
              )}
              alt={username}
            />
          </Link>
        )} */}
        <div className="content-head">
          <div className="between">
            {!hideUsername && <div className="brand-name">{supplier}</div>}
            {isPrivate && (
              <div className="private">
                <MdLock />
                비공개
              </div>
            )}
          </div>
          <div className="title" style={{ WebkitBoxOrient: 'vertical' }}>
            {title}
          </div>
          {!!(price && price !== '0' && price !== 0) && (
            <div className="price">
              <span>
                {numberWithCommas(price)}
                <span className="price-unit">원</span>
              </span>
            </div>
          )}
          <div className="badges">
            {displayBadges.map(badge => (
              <div className="badge" key={badge.name} style={{ backgroundColor: badge.color }}>
                <div className="text">{badge.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
};

ProductCard.defaultProps = {
  oneColumn: false,
  hideUsername: false,
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/common/ProductCard/ProductCard.js